import { customAxios, FDV_URL, IDUSUARIO, USERNAME } from '../constants';
import { FETCH_FACTURACION, FETCH_FACTURACION_EDIT, FETCH_FACTURACION_GRABAR } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchFacturacion(numero, tipoListado, indPaginado, nroPag, cantidadxPag,numPedidoVehiculo) {
  const config = {
    headers: {
      indPaginado: indPaginado.length ? indPaginado : 'N',
      nroPag: nroPag.length ? nroPag : '1',
      cantidadxPag: cantidadxPag.length ? cantidadxPag : '10',
    },

    params: {
      tipoListado: tipoListado.length ? tipoListado : null,
      numPedidoVehiculo,
    },
  };

  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${numero}/facturaciones`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))
                          // .then(({ data }) => actionError(data, 'facturacion'));

  return {
    type: FETCH_FACTURACION,
    payload: request,
  };
}



export function fetchEditarFacturacion(numero, numPedidoVeh, numProfVeh, codClie, codPropietarioVeh, codUsuarioVeh, desClie, desPropietarioVeh, desUsuarioVeh) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
    params: {
      numPedidoVeh: numPedidoVeh === null ? '' : numPedidoVeh,
      numProfVeh: numProfVeh === null ? '' : numProfVeh,
      codClie: codClie === null ? '' : codClie,
      codPropietarioVeh: codPropietarioVeh === null ? '' : codPropietarioVeh,
      codUsuarioVeh: codUsuarioVeh === null ? '' : codUsuarioVeh,

      desClie: desClie === null ? '' : desClie,
      desPropietarioVeh: desPropietarioVeh === null ? '' : desPropietarioVeh,
      desUsuarioVeh: desUsuarioVeh === null ? '' : desUsuarioVeh,
    },
  };

  const data = {

  };

  const request = customAxios.put(`${FDV_URL}/ficha-venta/fichas-venta/${numero}/facturaciones`, data, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_FACTURACION_EDIT,
    payload: request,
  };
}

export function fetchGrabarFacturacion(
  numero,
  numeroPedido,
  codCia,
  codColaborador,
  codDocumentoFact,
  codEntidadFinan,
  codMotiNotificacion,
  codPerDir,
  codProv,
  codTipoPago,
  codTipoSol,
  contactosAdici,
  direccion,
  documento,
  entidadFinan,
  indInactivo,
  indSolicitudFact,
  nomCliente,
  numFichaVenta,
  numPedidoVehiculo,
  numProforma,
  numRegDir,
  obsFacturacion,
  obsNotificacion,
  obsSolFacturacion,
  tipoCorreo,
  tipoPago,
  tipoRefProc,
  tipoSoli,
  tipoSolicitudFact,
  nurPedido,
  desSolicitudFact
) {

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME,
    },
    params: {
    },
  };
  const data = {
                codCia: codCia === null ? '' : codCia,
                codColaborador: codColaborador === null ? '' : codColaborador,
                codDocumentoFact: codDocumentoFact === null ? '' : codDocumentoFact,
                codEntidadFinan: codEntidadFinan === null ? '' : codEntidadFinan,
                codMotiNotificacion: codMotiNotificacion === null ? '' : codMotiNotificacion,
                codPerDir: codPerDir === null ? '' : codPerDir,
                codProv: codProv === null ? '' : codProv,
                codTipoPago: codTipoPago === null ? '' : codTipoPago,
                codTipoSol: codTipoSol === null ? '' : codTipoSol,
                contactosAdici: contactosAdici === null ? '' : contactosAdici,
                direccion: direccion === null ? '' : direccion,
                documento: documento === null ? '' : documento,
                entidadFinan: entidadFinan === null ? '' : entidadFinan,
                indInactivo: indInactivo === null ? '' : indInactivo,
                indSolicitudFact: indSolicitudFact === null ? '' : indSolicitudFact,
                nomCliente: nomCliente === null ? '' : nomCliente,
                numFichaVenta: numFichaVenta === null ? '' : numFichaVenta,
                numPedidoVehiculo: numPedidoVehiculo === null ? '' : numPedidoVehiculo,
                numProforma: numProforma === null ? '' : numProforma,
                numRegDir: numRegDir === null ? '' : numRegDir,
                obsFacturacion: obsFacturacion === null ? '' : obsFacturacion,
                obsNotificacion: obsNotificacion === null ? '' : obsNotificacion.replace(/\n/g, "<br />"),
                obsSolFacturacion: obsSolFacturacion === null ? '' : obsSolFacturacion.replace(/\n/g, "<br />"),
                tipoCorreo: tipoCorreo === null ? '' : tipoCorreo,
                tipoPago: tipoPago === null ? '' : tipoPago,
                tipoRefProc: tipoRefProc === null ? '' : tipoRefProc,
                tipoSoli: tipoSoli === null ? '' : tipoSoli,
                tipoSolicitudFact: tipoSolicitudFact === null ? '' : tipoSolicitudFact,
                nurFichaVtaPedido:nurPedido,
                desSolicitudFact: desSolicitudFact === null ? '' : desSolicitudFact,

              };

  const request = customAxios.post(`${FDV_URL}/ficha-venta/fichas-venta/${numero}/pedidos/${numeroPedido}/graba-info-facturacion`, data, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_FACTURACION_GRABAR,
    payload: request,
  };
}

export function fetchSolicitudesFacturacion(numero, numProfVeh, numPedidoVeh) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME
    },
    params: {
      numPedidoVeh: numPedidoVeh === null ? '' : numPedidoVeh
    },
  };

  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${numero}/pedido/${numProfVeh}/solicitud-facturacion`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_FACTURACION_EDIT,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/Facturacion.js